import { render, staticRenderFns } from "./GoodsLend.vue?vue&type=template&id=6fb75a41"
import script from "./GoodsLend.vue?vue&type=script&lang=js"
export * from "./GoodsLend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports